import { numberToWordsVi } from "./numbers.ts";

/** Turn on-screen math text into natural Vietnamese for TTS (SPEC §9.6). */
const UNITS: Record<string, string> = {
  cm: "xăng-ti-mét",
  dm: "đề-xi-mét",
  m: "mét",
  km: "ki-lô-mét",
  kg: "ki-lô-gam",
  l: "lít",
};

const NUM = String.raw`\d{1,3}(?: \d{3})+|\d+`;
const read = (digits: string): string => numberToWordsVi(Number(digits.replace(/ /g, "")));

export function toSpeechVi(text: string): string {
  let s = text.normalize("NFC");
  // time 9:30 (no spaces around ":") → "chín giờ ba mươi phút"
  // (no regex lookbehind anywhere: Safari < 16.4 cannot even parse it)
  s = s.replace(/(^|\D)(\d{1,2}):(\d{2})(?!\d)/g, (_m, pre: string, h: string, mm: string) => {
    const minutes = Number(mm);
    return `${pre} ${read(h)} giờ${minutes ? ` ${read(mm)} phút` : ""} `;
  });
  // date (ngày) 20/11 → "ngày hai mươi tháng mười một"
  s = s.replace(
    /(^|\D)(?:ngày\s+)?(\d{1,2})\/(\d{1,2})(?!\d)/g,
    (_m, pre: string, d: string, mo: string) => {
      return `${pre} ngày ${read(d)} tháng ${read(mo)} `;
    },
  );
  // number + unit while the number is still digits (units are ASCII, so no Unicode word issue)
  s = s.replace(
    new RegExp(`(${NUM})\\s*(cm|dm|km|kg|m|l)(?![\\p{L}\\d])`, "gu"),
    (_m, n: string, u: string) => ` ${read(n)} ${UNITS[u]} `,
  );
  s = s.replace(new RegExp(NUM, "g"), (m) => ` ${read(m)} `);
  s = s
    .replace(/\[[^\]]*\]/g, " mấy ")
    .replace(/(^|\s)\?(?=\s|$)/g, " mấy ")
    .replace(/\s*\+\s*/g, " cộng ")
    .replace(/\s[-–−]\s/g, " trừ ")
    .replace(/\s*×\s*/g, " nhân ")
    .replace(/\s:\s/g, " chia ")
    .replace(/\s*=\s*/g, " bằng ")
    .replace(/\s*>\s*/g, " lớn hơn ")
    .replace(/\s*<\s*/g, " bé hơn ")
    .replace(/\p{Extended_Pictographic}/gu, "");
  return s
    .replace(/\s+/g, " ")
    .replace(/\s+([.,!?;:])/g, "$1")
    .trim();
}
